var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
import { BodyLong } from "../typography/index.js";
export const LinkPanelDescription = forwardRef((_a, ref) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const { cn } = useRenameCSS();
    return (React.createElement(BodyLong, Object.assign({}, rest, { as: "div", ref: ref, className: cn("navds-link-panel__description", className) })));
});
export default LinkPanelDescription;
//# sourceMappingURL=LinkPanelDescription.js.map